export const newsImageConfig = {
	allowedContentTypes: ["image/jpeg", "image/png", "image/webp"],
	maxImagesPerNewsItem: 3,
	maxSizeInBytes: 10 * 1024 * 1024,
	variantNames: { full: "full", thumbnail: "thumb" },
} as const
